import Confirm from "./confirm";

const ConfirmReceipt = () => {
    return (
        <Confirm />
    )
}

export default ConfirmReceipt;